<template>
  <div class="cooperation_application">
    <div class="s_wrapper">
      <el-date-picker v-model="datetime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="handleSelectData" value-format="yyyy-MM-dd"></el-date-picker>
      <el-button type="primary" @click="dialogVisible = true">发布</el-button>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="picUrl" label="封面">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.picUrl" @click="previewImage(scope.row.picUrl)"></el-image>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="title" label="标题"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createdTime" label="发布时间"></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" width="120">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleShow(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
    <el-dialog title="发布" :visible.sync="dialogVisible" :before-close="onCancel">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="ruleForm">
        <el-form-item label="项目图片" prop="picUrl">
          <el-upload class="upload-demo" ref="upload" accept=".png,.jpeg,.jpg" :file-list="fileList" :limit="1" name="multipartFile" :headers="headers" :action="action" :on-success="busiLicenseSuccess" :before-upload="beforeUploads" :on-remove="handleRemove" :on-exceed="onExceed" list-type="picture">
            <el-button type="primary">点击上传</el-button>
            <div slot="tip" class="el_upload__tip">
              <i class="el-icon-warning"></i>
              <span>请确保项目图片信息清晰可见，图片格式仅支持jpg、jpeg、png，图片大小不超过5MB。</span>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="ruleForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="正文" prop="content">
          <vue-word-editor v-model="ruleForm.content" :config="config" ref="wordeditor"></vue-word-editor>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false
        }
      "
      :url-list="imgList"
    ></el-image-viewer>
  </div>
</template>

<script>
import VueWordEditor from "vue-word-editor"
import "quill/dist/quill.snow.css"
export default {
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
    VueWordEditor,
  },
  data() {
    return {
      // 图片预览
      showViewer: false,
      imgList: [],
      headers: { token: this.$store.state.token },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
      fileList: [],
      dialogVisible: false,
      tableData: [],
      datetime: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
      ruleForm: {
        title: "",
        picUrl: "",
        picId: "",
        content: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        picUrl: [{ required: true, message: "缺少项目图片", trigger: "blur" }],
      },
      config: {
        placeholder: "请输入内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            ["link", "image"],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction
          ],
        },
        // 上传图片的配置
        uploadImage: {
          url: this.$axios.defaults.baseURL + this.$api.uploadFile,
          name: "multipartFile",
          headers: this.getToken(),
          // res是结果，insert方法会把内容注入到编辑器中，res.data.url是资源地址
          uploadSuccess: (res, insert) => {
            insert(res.data.result.fileUrl)
          },
          showProgress: false,
        },
      },
    }
  },
  created() {
    this.selectNoticeInfoAllList()
    console.log()
  },
  methods: {
    getToken() {
      return {
        Token: JSON.parse(localStorage.getItem("vuex")).token,
      }
    },
    // 图片放大
    previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    }, // 时间搜索
    handleSelectData(value) {
      this.datetime = value
      this.clearData()
      this.selectNoticeInfoAllList()
    },
    handleShow(row) {
      // 路由传参跳转
      this.$router.push({
        path: "/announcement/list/details",
        query: {
          id: row.id,
        },
      })
    },
    // 发布
    submitForm(ruleForm) {
      this.ruleForm.content = this.$refs.wordeditor.editor.root.innerHTML
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          this.$axios
            .post(this.$api.insertNoticeInfo, {
              content: this.ruleForm.content,
              picUrl: this.ruleForm.picUrl,
              title: this.ruleForm.title,
            })
            .then(res => {
              if (res.code == 100) {
                this.selectNoticeInfoAllList()
                this.onCancel()
                this.$message({
                  message: res.desc,
                  type: "success",
                })
              } else {
                this.$message({ showClose: true, message: res.desc, type: "error" })
              }
            })
        } else {
          return false
        }
      })
    },
    onCancel() {
      this.dialogVisible = false
      this.handleRemove()
      this.ruleForm = {}
      this.$refs.upload.clearFiles()

      this.$refs.wordeditor.editor.root.innerHTML = ""
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 删除营业执照
    handleRemove() {
      this.$refs.upload.clearFiles()
    },
    onExceed() {
      this.$message.error("最多只能上传一张图片，请删除后重新上传")
    },
    // 项目图片上传成功
    busiLicenseSuccess(res) {
      if (res.code == 100) {
        this.ruleForm.picId = res.result.fileId
        this.ruleForm.picUrl = res.result.fileUrl
      } else {
        this.$message({ showClose: true, message: res.desc, type: "error" })
      }
      // console.log(this.ruleForm.picUrl);
    },
    // 文件上传
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!")
      }
      return isJPG && isLt5M
    },
    // 获取列表
    selectNoticeInfoAllList() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      // 时间区间
      if (this.datetime && this.datetime.length === 2) {
        params.startTime = this.datetime[0]
        params.endTime = this.datetime[1]
      } else {
        params.startTime = null
        params.endTime = null
      }
      this.$axios
        .get(this.$api.selectNoticeInfoAllList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectNoticeInfoAllList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectNoticeInfoAllList()
    },
  },
}
</script>

<style scoped lang="scss">
.cooperation_application {
  .el-icon-warning {
    color: #0096ff;
    font-size: 16px;
  }
  ::v-deep .el-upload-list {
    width: 30% !important;
  }
  ::v-deep .el-dialog .el-input__inner {
    width: 320px !important;
  }
  #vue-editor-wrapper {
    width: 70%;
  }
}
</style>
